import { Post } from "services";
import { ApiPath } from "paths";

export const searchDeviceSyncReport = async (body) => {
  const res = await Post(`${ApiPath.SYNC_SEARCH}`, body);
  return res;
};
